<div class="vehicle-assignment-container" *transloco="let t; prefix: 'vehicleAssignment'">
  <div class="vehicle-assignment-header">
    <div class="title">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
    <div class="search-drivers">
      <app-search [placeholder]="t('searchPlaceholder')" [disabled]="isLoading" [customWidth]="'340px'"
      (searchTermUpdated)="onSearchTermUpdate($event)"></app-search>
    </div>
    <div class="driver-search-filter">
      <app-account-filter [filter]="accountFilter" class="w-50 py-2"
      (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
    </div>
  </div>

  @if (hasFleetManagerRole) {
    <div class="bulk-assignment-container">
      <div class="bulk-assignment-title">
        <span>
          {{ t('bulk.title') }}
        </span>
      </div>
      <div class="bulk-inputs-control-container">
        <div class="driver-selection-container">
          <span class="input_heading">{{ t('bulk.driverAccount') }}</span>
          <app-asset-assignment-filter [isLoaded]="driversLoaded" [filter]="assignmentFilter"
            [tree]="hierarchicalDriversTree" [entityType]="'driver'"
            [labelTitle]="t('bulk.selectDrivers')" [isBulkAssignment]="isBulkAssignment"
            (driverAssignmentFilterChanged)="onFilterChanged($event)">
          </app-asset-assignment-filter>
        </div>
        <div class="vehicle-selection-container">
          <span class="input_heading">{{ t('bulk.vehicleAccount') }}</span>
          <app-asset-assignment-filter [isLoaded]="assetsLoaded" [filter]="assignmentFilter"
            [tree]="hierarchicalAssetsTree" [entityType]="'asset'"
            [labelTitle]="t('bulk.selectVehicles')" [isBulkAssignment]="isBulkAssignment"
            (driverAssignmentFilterChanged)="onFilterChanged($event)">
          </app-asset-assignment-filter>
        </div>
        <div class="unassign-btn-container">
          <button class="btn btn-primary" (click)="openBulkUnassignModal()" [disabled]="buttonDisabled">
            <span>{{ 'common.unassign' | transloco }}</span>
          </button>
        </div>
        <div class="assign-btn-container">
          <button type="submit" class="btn btn-primary" (click)="openBulkAssignModal()" [disabled]="buttonDisabled">
            <span>{{ 'common.assign' | transloco }}</span>
          </button>
        </div>
      </div>
    </div>
  }

  <div class="assignment-table-container">
    <table class="table">
      <thead>
        <tr>
          <th>{{ t('table.driver') }}</th>
          <th>{{ t('table.assignedVehicles') }}</th>
          <th>
            <span>
              {{ t('table.pendingAssignment') }}
            </span>
            <span>
              <svg [ngbTooltip]="t('table.pendingAssignmentTooltip')" placement="top" [container]="'body'"
                width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.5 1.75C4.05375 1.75 1.25 4.55375 1.25 8C1.25 11.4462 4.05375 14.25 7.5 14.25C10.9462 14.25 13.75 11.4462 13.75 8C13.75 4.55375 10.9462 1.75 7.5 1.75ZM7.5 13C4.74313 13 2.5 10.7569 2.5 8C2.5 5.24313 4.74313 3 7.5 3C10.2569 3 12.5 5.24313 12.5 8C12.5 10.7569 10.2569 13 7.5 13Z"
                  fill="#9FA1A4" />
                  <path d="M6.875 7.375H8.125V11.125H6.875V7.375ZM6.875 4.875H8.125V6.125H6.875V4.875Z" fill="#9FA1A4" />
                </svg>

              </span>
            </th>
            <th>
              <span>
                {{ t('table.pendingUnassignment') }}
              </span>
              <span>
                <svg [ngbTooltip]="t('table.pendingUnassignmentTooltip')" placement="top" [container]="'body'"
                  width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.5 1.75C4.05375 1.75 1.25 4.55375 1.25 8C1.25 11.4462 4.05375 14.25 7.5 14.25C10.9462 14.25 13.75 11.4462 13.75 8C13.75 4.55375 10.9462 1.75 7.5 1.75ZM7.5 13C4.74313 13 2.5 10.7569 2.5 8C2.5 5.24313 4.74313 3 7.5 3C10.2569 3 12.5 5.24313 12.5 8C12.5 10.7569 10.2569 13 7.5 13Z"
                    fill="#9FA1A4" />
                    <path d="M6.875 7.375H8.125V11.125H6.875V7.375ZM6.875 4.875H8.125V6.125H6.875V4.875Z" fill="#9FA1A4" />
                  </svg>

                </span>
              </th>
              @if (hasFleetManagerRole) {
                <th>{{ t('table.actions') }}</th>
              }
            </tr>
          </thead>
          @if (isLoading || (!assetsLoaded() || !driversLoaded())) {
            <tbody>
              <tr>
                <td [attr.colspan]="hasFleetManagerRole ? 5 : 4">
                  <div class="spinner-container">
                    <span class="spinner-border text-light"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          }
          @if (!isLoading && assetsLoaded() && driversLoaded()) {
            <tbody>
              @if (hasLoaded && !driverAssignedVehicles?.length) {
                <div class="no-data">
                  <span>{{ 'common.noDataFound' | transloco }}</span>
                </div>
              }
              @for (driver of driverAssignedVehicles; track driver) {
                <app-driver-vehicle-assignment-row [driver]="driver" [hasFleetManagerRole]="hasFleetManagerRole"
                  [hierarchicalAssetsTree]="hierarchicalAssetsTree" (assignmentUpdated)="refreshList()"
                  [assetsLoaded]="assetsLoaded">
                </app-driver-vehicle-assignment-row>
              }
            </tbody>
          }
        </table>

        @if (!isLoading && driverAssignedVehicles.length > 0 && assetsLoaded() && driversLoaded()) {
          <div
            class="pagination-container p-3">
            <div class="pagination-inner">
              <div class="items-lbl">{{ 'common.showingOutOf' | transloco: { current: currentItems, total: totalItems } }}</div>
              <app-pagination [totalPages]="numberOfPages" [currentPage]="currentPage"
              (pageChange)="createPagination($event)"></app-pagination>
            </div>
          </div>
        }
      </div>
    </div>